import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Award, X } from 'lucide-react';
import { certificates } from '../data/mockData';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Badge } from './ui/badge';

const Certificates = () => {
  const [selectedCert, setSelectedCert] = useState(null);

  return (
    <section id="certificates" className="py-20 bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            <Award className="inline-block mb-2 text-cyan-400" size={40} />{' '}
            <span className="bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">Certificates</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            My learning journey with {certificates.length}+ certifications
          </p>
        </motion.div>

        {/* Certificates Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {certificates.map((cert, index) => (
            <motion.div
              key={cert.id}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              viewport={{ once: true }}
              whileHover={{ scale: 1.05 }}
              onClick={() => setSelectedCert(cert)}
              className="group relative cursor-pointer rounded-lg overflow-hidden border border-gray-700 hover:border-cyan-400/50 transition-all"
            >
              <div className="aspect-video bg-gray-800 relative overflow-hidden">
                <img
                  src={cert.image}
                  alt={cert.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-3 bg-gray-900/95 backdrop-blur-sm transform translate-y-full group-hover:translate-y-0 transition-transform">
                <p className="text-white text-sm font-semibold line-clamp-2">{cert.name}</p>
                <p className="text-cyan-400 text-xs mt-1">{cert.issuer}</p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Certificate Modal */}
        <Dialog open={!!selectedCert} onOpenChange={() => setSelectedCert(null)}>
          <DialogContent className="max-w-4xl bg-gray-900 border-gray-700">
            <DialogHeader>
              <DialogTitle className="text-2xl font-bold text-white">
                {selectedCert?.name}
              </DialogTitle>
            </DialogHeader>
            <div className="space-y-4">
              <div className="flex gap-4 items-center">
                <Badge className="bg-cyan-500/20 text-cyan-400 border-cyan-400/30">
                  {selectedCert?.issuer}
                </Badge>
                <Badge className="bg-blue-500/20 text-blue-400 border-blue-400/30">
                  {selectedCert?.date}
                </Badge>
              </div>
              <div className="rounded-lg overflow-hidden border border-gray-700">
                <img
                  src={selectedCert?.image}
                  alt={selectedCert?.name}
                  className="w-full h-auto"
                />
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </section>
  );
};

export default Certificates;